import React, { useEffect, useState } from "react";
import axios from "axios";
import { Mic } from "lucide-react";
import { LineRecordControl } from "../../pages/AskAiJourneyModal";
import { API, auth, TOK, SERIF, SANS, PrimaryBtn, Title, flattenLines } from "./shared";

// Record step, purist route: the agreed words listed, each recorded in the user's own voice.
export const RecordOwnStep = ({ sections, onContinue }) => {
  const lines = flattenLines(sections);
  const [match, setMatch] = useState({});
  useEffect(() => {
    if (!lines.length) return;
    axios.post(`${API}/api/user-voice-bank/match`, { texts: lines }, auth())
      .then((r) => setMatch(r.data?.results || {})).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const done = lines.filter((t) => match[t]?.recorded).length;
  return (
    <div className="space-y-6" data-testid="simple-record-own-step">
      <div>
        <Title>Record your words</Title>
        <p className="mt-3 text-lg italic" style={{ color: TOK.creamDim, fontFamily: SERIF }}>Tap Record on each line and read it naturally.</p>
      </div>
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs" data-testid="simple-record-own-progress"
        style={{ border: `1px solid ${TOK.gold}`, color: TOK.gold, fontFamily: SANS }}>
        <Mic size={11} /> {done} of {lines.length} recorded
      </span>
      <ul className="border-t" style={{ borderColor: "rgba(215,187,122,0.16)" }} data-testid="simple-record-own-lines">
        {lines.map((t, i) => (
          <li key={i} className="py-4 pl-3 border-b" data-testid={`simple-record-own-line-${i}`}
            style={{ borderColor: "rgba(215,187,122,0.16)", boxShadow: match[t]?.recorded ? `inset 2px 0 0 ${TOK.gold}` : "none" }}>
            <p className="text-lg leading-snug mb-2" style={{ color: TOK.cream, fontFamily: SERIF }}>{t}</p>
            <LineRecordControl text={t} matched={match[t]} testId={`simple-record-own-rec-${i}`}
              onRecorded={(e) => setMatch((m) => ({ ...m, [t]: { recorded: true, id: e.id, text_hash: e.text_hash, audio_url: e.audio_url } }))} />
          </li>
        ))}
      </ul>
      <PrimaryBtn testId="simple-record-own-continue" disabled={!done} onClick={onContinue}>Continue</PrimaryBtn>
      <p className="text-center text-xs" style={{ color: TOK.creamMist, fontFamily: SANS }}>Any line you don&apos;t record is spoken by the Soulumo voice.</p>
    </div>
  );
};
